import React from "react";
import "./admin-dashboard.css";
import { Link } from "react-router-dom";
import AdminSideBar from "./AdminSideBar";

function AdminDashboard() {
  return (
    <main className="admin-page">
      <div className="admin-layout">
        
    
    <AdminSideBar />
        <section className="admin-main">
          <header className="admin-main-header">
            <h2 className="admin-main-title">Users</h2>
            <p className="admin-main-subtitle">
              Overview and quick actions for users.
            </p>
          </header>

          <div className="admin-main-body">
            <div className="admin-content-card">
              <h2>Users</h2>
              <p>Manage employees, roles, and access permissions.</p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default AdminDashboard;